// extracted by mini-css-extract-plugin
export default {"title":"Products_title__7C2x0","description":"Products_description__sRQ7r"};